import type { FC, ReactNode } from 'react'

import { useId } from 'react'
import { cn } from '@/lib/utils'

interface LogoMarkProps {
    className?: string
}

/** Two interlocked loops inside a circle: the Quayside knot. */
export const LogoMark: FC<LogoMarkProps> = ({ className }): ReactNode => {
    const id = useId().replace(/[^a-zA-Z0-9_-]/g, '')

    return (
        <svg viewBox='0 0 32 32' fill='none' aria-hidden='true' className={className}>
            <defs>
                <mask id={`${id}-a`} maskUnits='userSpaceOnUse' x='0' y='0' width='32' height='32'>
                    <rect width='32' height='32' fill='white' />
                    <circle cx='16' cy='12.13' r='1.95' fill='black' />
                </mask>

                <mask id={`${id}-b`} maskUnits='userSpaceOnUse' x='0' y='0' width='32' height='32'>
                    <rect width='32' height='32' fill='white' />
                    <circle cx='16' cy='19.87' r='1.95' fill='black' />
                </mask>
            </defs>

            <circle cx='16' cy='16' r='14.75' stroke='currentColor' strokeWidth='1.5' />
            <rect x='7' y='12' width='12' height='8' rx='4' stroke='currentColor' strokeWidth='1.7' mask={`url(#${id}-a)`} />
            <rect x='13' y='12' width='12' height='8' rx='4' stroke='currentColor' strokeWidth='1.7' mask={`url(#${id}-b)`} />
        </svg>
    )
}

interface LogoProps {
    className?: string
    markClassName?: string
}

export const Logo: FC<LogoProps> = ({ className, markClassName }): ReactNode => {
    return (
        <span className={cn('inline-flex items-center gap-2', className)}>
            <LogoMark className={cn('size-7', markClassName)} />
            <span className='font-heading text-[17px] font-semibold tracking-[-0.03em]'>
                Quayside
            </span>
        </span>
    )
}
